import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
	selector: "ic-tree-view-item-title",
	templateUrl: "./tree-view-item-title.component.html",
	styleUrls: ["./tree-view-item-title.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TreeViewItemTitleComponent {}
